import { EnumSchema } from '../metadata-schema';

export const CohortrendementVanafNiveau: EnumSchema = {
	"type": "string",
	"title": "CohortrendementVanafNiveau",
	"enum": [
		"Afgestroomd",
		"Zonder vertraging",
		"Opgestroomd"
	]
};
